import {
    Box,
    Button,
    TextField,
    Select,
    MenuItem,
    useMediaQuery,
    InputLabel,
    Typography,
    useTheme,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../global/Header";
import { SelectChangeEvent } from "@mui/material";
import React from 'react'
import { useAddNewUserMutation } from "../../../features/users/usersApiSlice";
import { useState } from "react";
import { tokens } from "../../../theme"
import { useParams, Link, useNavigate } from "react-router-dom"
import useAuth from "../../../hooks/useAuth";



const initialValues = {
    name: "",
    username: "",
    password: "",
    email: "",
    role: ""

}
//go back for email validation
const userSchema = yup.object().shape({
    name: yup.string(), //.required("Required"),
    username: yup.string(),//.required("Required"),
    password: yup.string(), //.required("Required"),
    email: yup.string(), //.required("Required"),
    role: yup.string() //.required("Required"),
})



const UserForm = () => {
    const { username, isManager, isAdmin } = useAuth()
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const params = useParams()
    var organization_id = params.organization_id
    const org_user = !(!organization_id) //True if adding an org user
    console.log("Organization ID: ", params.organization_id)
    console.log("org_user ID: ", org_user)
    const isNonMobile = useMediaQuery("(min-width:600px");
    const navigate = useNavigate();

    const [addNewUser, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewUserMutation()

    /* ---------- success dialog state ---------- */
    const [openDialog, setOpenDialog] = useState(false);

    /* open dialog when mutation succeeds */
    React.useEffect(() => {
        if (isSuccess) setOpenDialog(true);
    }, [isSuccess]);

    const handleDialogClose = () => {
        setOpenDialog(false);
        navigate("/console/users");
    };

    const handleFormSubmit = (values) => {
        console.log(values)
        const name = values.name
        const username = values.username
        const password = values.password
        const email = values.email

        var role = selected

        if (role === 'Admin') {
            organization_id = 'admin'
        }
        console.log("Full user: ", { name, username, password, email, role, organization_id })
        addNewUser({ name, username, password, email, role, organization_id })
    }

    const [selected, setSelected] = useState([]);

    const selectionChangeHandler = (event) => {
        setSelected(event.target.value);
    };


    return (
        <Box
            m="20px">
            <Header title={`REGISTER USER`} subtitle="Create a new user" />

            <Formik
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={userSchema}>
                {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Box
                            display="grid"
                            gap="30px"
                            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                            sx={{
                                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" }
                            }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.name}
                                name="name"
                                error={!!touched.name && !!errors.name}
                                helperText={touched.name && errors.name}
                                sx={{ gridColumn: "span 2" }}
                            />
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Username"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.username}
                                name="username"
                                error={!!touched.username && !!errors.username}
                                helperText={touched.username && errors.username}
                                sx={{ gridColumn: "span 2" }}
                            />
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Password"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.password}
                                name="password"
                                error={!!touched.password && !!errors.password}
                                helperText={touched.password && errors.password}
                                sx={{ gridColumn: "span 2" }}
                            />
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Email"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.email}
                                name="email"
                                error={!!touched.email && !!errors.email}
                                helperText={touched.email && errors.email}
                                sx={{ gridColumn: "span 2" }}
                            />
                            <InputLabel name="role-label">Role</InputLabel>
                            <Select
                                id="role"
                                name="role"
                                value={selected}
                                onChange={selectionChangeHandler}
                            >
                                {isAdmin === true && <MenuItem value="Admin">Admin</MenuItem>}
                                {isAdmin === true && <MenuItem value="Read-Only">Read-Only</MenuItem>}
                                <MenuItem value="Manager">Manager</MenuItem>
                                <MenuItem value="User">User</MenuItem>
                            </Select>
                            {((selected === 'Manager' || selected === 'User') && !org_user) &&
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Organization ID"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.organization_id}
                                    name="organization_id"
                                    error={!!touched.organization_id && !!errors.organization_id}
                                    helperText={touched.organization_id && errors.organization_id}
                                    sx={{ gridColumn: "span 2" }}
                                />
                            }
                            {org_user &&
                                <Typography variant="h4" color={colors.blueAccent[500]}>
                                    Organization ID: {organization_id}
                                </Typography>
                            }

                        </Box>
                        <Box display="flex" justifyContent="end" mt="20px">
                            <Button type="submit" color="secondary" variant="contained">
                                Create New User
                            </Button>
                        </Box>
                    </form>
                )}
            </Formik>

            {/* ---------- confirmation dialog ---------- */}
            <Dialog
                open={openDialog}
                onClose={handleDialogClose}
                aria-labelledby="user-added-title"
            >
                <DialogTitle id="user-added-title">User Created</DialogTitle>
                <DialogContent>
                    <Typography>
                        The new user has been created and login instructions have been sent
                        to their e-mail.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} variant="contained">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default UserForm